export const caseLevelLabels = {
    new: {
        id: 'whistleblowing_case_status_new',
        defaultMessage: 'Unseen'
    },
    seen: {
        id: 'whistleblowing_case_status_seen',
        defaultMessage: 'Seen'
    },
    acknowledged: {
        id: 'whistleblowing_case_status_acknowledged',
        defaultMessage: 'Open'
    },
    closed: {
        id: 'whistleblowing_case_status_closed',
        defaultMessage: 'Closed'
    }
}

export const unresolvedStatusesFilter = ['new', 'seen', 'acknowledged']